export default "__VITE_ASSET__ChD2G3G$__"